// Social and contact links for DayTradingTactics from environment variables
// Expected env variable names:
// REACT_APP_INSTAGRAM_URL, REACT_APP_YOUTUBE_URL, REACT_APP_FACEBOOK_URL, REACT_APP_TWITTER_URL, REACT_APP_MOBILE

const socialLinks = {
    instagram: (process.env.REACT_APP_INSTAGRAM_URL || '').replace(/^"|"$/g, ''),
    youtube: (process.env.REACT_APP_YOUTUBE_URL || '').replace(/^"|"$/g, ''),
    facebook: (process.env.REACT_APP_FACEBOOK_URL || '').replace(/^"|"$/g, ''),
    twitter: (process.env.REACT_APP_TWITTER_URL || '').replace(/^"|"$/g, ''),
    mobile: (process.env.REACT_APP_MOBILE || '').replace(/^"|"$/g, '')
};

export default socialLinks; 